import type { BadgeProps, MantineSize } from '@mantine/core';
import { IconBrandGithub } from '@tabler/icons-react';
import { CopyableBadge } from './CopyableBadge';

export function GitBranchBadge({
  gitBranch,
  badgeProps,
  size = 'sm',
}: {
  gitBranch: string;
  badgeProps?: BadgeProps;
  size?: MantineSize;
}) {
  return (
    <CopyableBadge
      value={gitBranch}
      displayValue={<span className="block truncate">{gitBranch}</span>}
      icon={
        <IconBrandGithub
          color="gray"
          size={14}
        />
      }
      size={size}
      badgeProps={{
        ...badgeProps,
        className: 'relative z-10 max-w-full',
      }}
    />
  );
}
